import { deleteReq, postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";
import { PaginatedSelectModel, emptyPaginatedSelectModel } from "@/models/core.model";
import { ClubMembershipStatusEnum, RunningClubMember, RunningClubMemberPaginationFilterRequest, UpsertRunningClubMember } from '@/models/running-club-member.model';

export const getPagedRunningClubMembers = async (input: RunningClubMemberPaginationFilterRequest): Promise<PagedResponseModel<RunningClubMember>> => {
  return await getReq(createUrl("a/RunningClub/Member/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

/** Active members of one club, for pickers that may only point at people who are
 *  actually in the club. Without a club there is nothing to list. */
export const getRunningClubMembersLookup = async (input?: string, runningClubId?: number, page?: number): Promise<PaginatedSelectModel> => {
  if (!runningClubId) {
    return emptyPaginatedSelectModel;
  }
  const model: RunningClubMemberPaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false,
    runningClubId: runningClubId,
    status: ClubMembershipStatusEnum.Active,
  };
  return await getPagedRunningClubMembers(model).then(data =>
    ({
      data: data.result.map(itm => ({
        value: itm.userId,
        label: `${itm.user.username} | ${itm.user.firstName} ${itm.user.lastName}`
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })
  );
};

export const getRunningClubMember = async (id: number): Promise<BaseResponseModel<RunningClubMember>> => {
  return await getReq(createUrl(`a/RunningClub/Member/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertRunningClubMember = async (input: UpsertRunningClubMember): Promise<BaseResponseModel<RunningClubMember>> => {
  return await postReq(createUrl("a/RunningClub/Member/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const deleteRunningClubMember = async (id: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/RunningClub/Member/Delete/${id}`),
  ).then((res: any) => res.data);
};
